import getWindow from '../../utils/get-window'
import { appName } from '../../../__config__/env.json'

export const track = (action, label, value, callback, nonInteractive) => {
  return getWindow().dataLayer
    ? getWindow().dataLayer.push({
        event: 'gaTriggerEvent',
        gaEventCategory: appName,
        gaEventAction: action,
        gaEventLabel: label,
        gaEventValue: value,
        eventCallback: callback,
        gaNonInteractive: nonInteractive || 0
      })
    : console.log('gaEvent', { type: appName, action, label, value, callback, nonInteractive })
}

export const addDestinationFilterForEvents = (events) => {
  window.nerdEvents.addDestinationFilter(({ payload, context, destinations, skip }) => {
    if (events.includes(destinations.segment.getEventName(payload.name, payload.nerdAttributes))) {
      return [destinations.segment]
    }

    return skip()
  })
}

export const trackSegment = (event, properties) => {
  const nerdalytics = getWindow().nerdalytics

  nerdalytics && nerdalytics.track(event, properties, () => {})
}

export const sendFbTrack = () => {
  window.fbq('init', '233540540175673', {
    external_id: window.__uswitchUserId__
  })
  window.fbq(
    'track',
    'ViewContent',
    {
      content_category: 'broadband',
      content_name: 'broadband'
    },
    { event_id: window.fbEventId }
  )
}

export const hasAcceptedMarketing = () => {
  if (!window.uSwitch.cookie.read('cookie-preferences')) return false
  const cookieConsent = JSON.parse(window.uSwitch.cookie.read('cookie-preferences') || '')
  return cookieConsent.marketing || cookieConsent.social
}
